import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMenu, closeMenu } from '../../redux/slices/uiSlice';
import { FaChevronDown } from 'react-icons/fa';
import classes from './Navbar.module.scss';

const Navbar = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const menuOpen = useSelector((state) => state.ui.menuOpen);
  const [scrolled, setScrolled] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '/', type: 'route' },
    {
      name: 'Services',
      type: 'dropdown',
      items: [
        { name: 'Mobile App Development', href: '/services/mobile-app-development' },
        { name: 'Web Development', href: '/services/web-development' },
        { name: 'E-commerce Development', href: '/services/ecommerce-development' },
        { name: 'UI/UX Design', href: '/services/ui-ux-design' },
        { name: 'AI/ML Development', href: '/services/ai-ml-development' },
        { name: 'Cloud DevOps Infrastructure', href: '/services/cloud-devops-infrastructure' },
        { name: 'Digital Marketing', href: '/services/digital-marketing' },
      ]
    },
    { name: 'Portfolio', href: '#portfolio', type: 'scroll' },
    { name: 'Tech Stack', href: '#tech', type: 'scroll' },
    { name: 'Contact', href: '#contact', type: 'scroll' },
  ];

  const handleNavClick = (href, type) => {
    dispatch(closeMenu());
    setServicesOpen(false);
    
    if (type === 'scroll') {
      // If we're not on the home page, navigate to home first
      if (location.pathname !== '/') {
        window.location.href = '/' + href;
      } else {
        document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };
  
  const handleServicesToggle = () => {
    setServicesOpen(!servicesOpen);
  };

  return (
    <nav className={`${classes.navbar} ${scrolled ? classes.scrolled : ''}`}>
      <div className={classes.container}>
        <Link to="/" className={classes.logo}>
          <span className={classes.logoText}>Arsanyu</span>
        </Link>

        <ul className={`${classes.navLinks} ${menuOpen ? classes.active : ''}`}>
          {navLinks.map((link) => {
            if (link.type === 'dropdown') {
              return (
                <li key={link.name} className={classes.dropdown}>
                  <button 
                    className={classes.dropdownToggle}
                    onClick={handleServicesToggle}
                  >
                    {link.name} <FaChevronDown className={`${classes.chevron} ${servicesOpen ? classes.rotate : ''}`} />
                  </button>
                  <ul className={`${classes.dropdownMenu} ${servicesOpen ? classes.open : ''}`}>
                    {link.items.map((item) => (
                      <li key={item.name}>
                        <Link to={item.href} onClick={() => handleNavClick(item.href, 'route')}>
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              );
            } else if (link.type === 'route') {
              return (
                <li key={link.name}>
                  <Link to={link.href} onClick={() => handleNavClick(link.href, 'route')}>
                    {link.name}
                  </Link>
                </li>
              );
            } else {
              return (
                <li key={link.name}>
                  <a onClick={() => handleNavClick(link.href, 'scroll')} href={link.href}>
                    {link.name}
                  </a>
                </li>
              );
            }
          })}
          <li className={classes.ctaButton}>
            <a href="#contact" onClick={() => handleNavClick('#contact', 'scroll')}>
              Let's Talk
            </a>
          </li>
        </ul>

        <button
          className={`${classes.hamburger} ${menuOpen ? classes.active : ''}`}
          onClick={() => dispatch(toggleMenu())}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
